export default __webpack_public_path__ + "img/img_4.cf17df24.png";